import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import AddAgReport from './Create_AgReport';

const Agreports = ({ workspaceId, onClose }) => {
  const [rowData, setRowData] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [token, setToken] = useState(null);


  // Fetch reports data
  const fetchReports = async () => {
    try {
      const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/workspace-reports/${workspaceId}`);
      if (!response.ok) {
        if (response.status === 404) {
          console.warn('No reports found, displaying empty table.');
          setRowData([]); // Set empty data if 404 Not Found
        } else {
          throw new Error(`Error: ${response.statusText}`);
        }
      } else {
        const data = await response.json();
        setRowData(data);
      }
    } catch (error) {
      console.error('Error fetching reports:', error);
      setRowData([]); // Set empty data if any other error occurs
    }
  };
  

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    fetchReports();
  }, [workspaceId]);

  const linkCellRenderer = (params) => {
    return `<a href="${params.value}" target="_blank" rel="noopener noreferrer">View Report</a>`;
  };

  const metaCellRenderer = (params) => {
    const { table, dbType, database } = params.data.meta || {};
    return `${table || 'N/A'} | ${dbType || 'N/A'} | ${database || 'N/A'}`;
  };

  // Open Add Report modal with empty form
  const openAddModal = () => {
    setEditData(null);  // Clear any edit data
    setShowAddModal(true); // Open modal
  };

  const editReport = (data) => {
    setEditData(data);
    setShowAddModal(true);
  };

  const deleteReport = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this report?");
    if (!confirmDelete) {
      return; // Exit the function if the user cancels
    }
  
    try {
      await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/delete-report/${id}`, { method: 'DELETE',  
        headers: {
            'Authorization': `Bearer ${token}`
        }
     },
      );
      fetchReports(); // Refresh the report list
    } catch (error) {
      console.error('Error deleting report:', error);
    }
  };
  

  const columnDefs = [
    { headerName: "ID", field: "id" },
    { headerName: "Report Type", field: "report_type" },
    { headerName: "Report Link", field: "report_link", cellRenderer: linkCellRenderer },
    { headerName: "Box Folder ID", field: "box_folder_id" },
    { headerName: "Report Name", field: "report_name" },
    { headerName: "Status", field: "status" },
    { headerName: "Content Type", field: "report_content_type" },
    { headerName: "Created At", field: "createdat" },
    { headerName: "Meta Info", cellRenderer: metaCellRenderer },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: (params) => (
        <div className='Agreport-btns'>
          <button className='validate-btn' onClick={() => editReport(params.data)}>Edit</button>
          <button className='delete-btn' onClick={() => deleteReport(params.data.id)}>Delete</button>
        </div>
      ),
    },
  ];

  const handleAddReport = () => {
    fetchReports();
    setEditData(null); // Clear edit data after adding or updating
  };

  return (
    <div style={{ width: '70%', height: '60%' }}>
      <button onClick={openAddModal}>Add New Report</button>
      <button onClick={onClose}>Close</button>

      {showAddModal && (
        <AddAgReport
          onClose={() => setShowAddModal(false)}
          workspaceId={workspaceId}
          onAddReport={handleAddReport}
          initialData={editData} // Pass initial data for editing
        />
      )}

      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={rowData}
          pagination={true}
          paginationPageSize={10}
        />
      </div>
    </div>
  );
};

export default Agreports;
